module.exports = __webpack_public_path__ + "static/media/logo_white.204aa50b.svg";